import React from 'react';

import MainLayout from '../../components/layout/Main';
import FeatureIntro from '../../components/organisms/featureIntro';
import usePageTitle from '../../hooks/usePageTitle';
import { MainLayoutHeader } from '../../components/atoms/mainLayoutHeader';
import JobBoardImage from '../../assets/feature-intro-job-board.png';

export const JobBoardIntro = () => {
  usePageTitle('Job Board');

  return (
    <MainLayout
      containerProps={{
        pb: 0,
        minHeight: '100vh',
      }}
    >
      <MainLayoutHeader title="Job Board" />

      <FeatureIntro
        featureName="Job Board"
        title="Attract top talent. Fill roles faster."
        description="Power your community's job board with curated listings, applicant tracking, and insights &mdash; all in one place."
        features={[
          "Branded job board with your community's open roles",
          'Track applicants and measure hiring outcomes',
          'Manage employer companies and job postings effortlessly',
        ]}
        image={JobBoardImage}
        imageAlt="Job Board feature preview"
        ctaText="Book a demo"
        ctaLink="https://www.getro.com/demo?utm_source=getro&utm_medium=app&utm_campaign=job_board_upsell"
        footerNote="Included in Scale and Enterprise plans"
      />
    </MainLayout>
  );
};
